/**
 * Feature Code Directive
 * 특정 element 삭제에 한하여 사용(임시로 정책에서 사용)
 *
 * @since: 2018-03-29
 * @author: kdydesign.kim
 *
 * TAMS 미사용 피처 관련 설계 다름
 */

export default {
  name: 'feature',
  bind (el, binding, vnode) {
    const
      uiData = vnode.context.$store.state.common.common.uiData,
      feature = uiData.license.SWFeature

    if (binding.value === 'Basic') {
      return
    }

    if (feature[binding.value]) {
      if (!feature[binding.value].Use) {
        el.style.display = 'none'
      }
    } else {
      el.style.display = 'none'
    }
  }
}
